const SiteAtmosphere = () => (
  <div className="site-atmosphere" aria-hidden="true">
    <div className="site-atmosphere__base" />
    <div className="site-atmosphere__grid" />
    <div className="site-atmosphere__orb site-atmosphere__orb--a" />
    <div className="site-atmosphere__orb site-atmosphere__orb--b" />
    <div className="site-atmosphere__orb site-atmosphere__orb--c" />
    <svg className="site-atmosphere__network" viewBox="0 0 1600 1000" preserveAspectRatio="xMidYMid slice">
      <g fill="none" stroke="currentColor">
        <path d="M-120 720 C260 420, 520 880, 900 560 S1450 260, 1720 520" />
        <path d="M-40 180 C380 520, 680 120, 1040 330 S1480 760, 1700 620" />
        <path d="M180 1040 C480 620, 760 800, 1100 520 S1440 160, 1620 220" />
        <path d="M340 -80 C520 260, 880 240, 1100 80 S1500 40, 1680 180" />
      </g>
      <g className="site-atmosphere__nodes">
        {[[190,615],[395,495],[620,685],[842,585],[1080,400],[1320,295],[320,375],[610,250],[900,330],[1190,510],[1450,650]].map(([cx,cy],i)=><circle key={i} cx={cx} cy={cy} r={i%4===0?4:2.5} />)}
      </g>
    </svg>
    <div className="site-atmosphere__grain" />
  </div>
);
export default SiteAtmosphere;
